/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaVnfSecuredConfiguration } from '../shiva-vnf-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { chargeWaterVolume } from '../fn/water-preloading/charge-water-volume';
import { ChargeWaterVolume$Params } from '../fn/water-preloading/charge-water-volume';
import { searchWaterPreloading } from '../fn/water-preloading/search-water-preloading';
import { SearchWaterPreloading$Params } from '../fn/water-preloading/search-water-preloading';
import { SubscriptionWaterPreloadingPagedList } from '../models/subscription-water-preloading-paged-list';


/**
 * All about the VNF Water Preloading
 */
@Injectable({ providedIn: 'root' })
export class WaterPreloadingService extends BaseService {
  constructor(config: ShivaVnfSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchWaterPreloading()` */
  static readonly SearchWaterPreloadingPath = '/custom/subscriptions/{uid}/water/preloading/search';

  /**
   * Search preloading of subscription's water, pageable and filterable by date.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchWaterPreloading()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchWaterPreloading$Response(params: SearchWaterPreloading$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionWaterPreloadingPagedList>> {
    return searchWaterPreloading(this.http, this.rootUrl, params, context);
  }

  /**
   * Search preloading of subscription's water, pageable and filterable by date.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchWaterPreloading$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchWaterPreloading(params: SearchWaterPreloading$Params, context?: HttpContext): Observable<SubscriptionWaterPreloadingPagedList> {
    return this.searchWaterPreloading$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionWaterPreloadingPagedList>): SubscriptionWaterPreloadingPagedList => r.body)
    );
  }

  /** Path part for operation `chargeWaterVolume()` */
  static readonly ChargeWaterVolumePath = '/custom/subscriptions/{uid}/water/preloading';

  /**
   * Charge a water volume.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chargeWaterVolume()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chargeWaterVolume$Response(params: ChargeWaterVolume$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return chargeWaterVolume(this.http, this.rootUrl, params, context);
  }

  /**
   * Charge a water volume.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chargeWaterVolume$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chargeWaterVolume(params: ChargeWaterVolume$Params, context?: HttpContext): Observable<void> {
    return this.chargeWaterVolume$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
